import React, { useEffect, useRef, useState } from "react";
import {
  Navbar,
  NavbarBrand,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  InputGroup,
  Input,
  Row,
  Col,
  Modal,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { isEmpty } from "lodash";
import Logo from "components/Logo";
import LogoPms from "assets/images/logo-pms.png";
import poweredBy from "assets/images/powered_by_pharmaforce.svg";
import user from "assets/icon/admin-purple.svg";
import star from "assets/icon/star-purple.svg";
import bell from "assets/icon/bell.svg";
import status from "assets/icon/status.svg";
import setting from "assets/icon/setting-purple.svg";
import messageIcon from "../assets/icon/message.svg";
import searchIcon from "../assets/icon/header-search.svg";
import closeIcon from "../assets/icon/close.svg";
import inputSearchIcon from "../assets/icon/input-search.svg";
import sampleIcon from "../assets/icon/sample.svg";
import windowIcon from "../assets/icon/window.svg";
import Logos from "../assets/sidebar/pendingIcon-dark.svg";
import workFlowIcon from "../assets/icon/workflow.svg";
import inventoryIcon from "../assets/icon/inventory-purple.svg";
import integrationIcon from "../assets/icon/integrations.svg";
import adminIcon from "../assets/icon/adminIcon.svg";
import pharmaForceLogo from "../assets/icon/pharmaforce-logo.svg";
import useOidc from "hooks/useOidc";
import claimsIconDark from "../assets/sidebar/claimsIcon-dark.svg";
import pendingIconDark from "../assets/sidebar/pendingIcon-dark.svg";
import orderentryIconDark from "../assets/sidebar/orderentryIcon-dark.svg";
// import paitentDarkIcon from "assets/icon/dark-paitent-icon.svg";
import initialRiewDarkIcon from "../assets/sidebar/initialReviewIcon-dark.svg";
import packagingIconDark from "../assets/sidebar/packagingIcon-dark.svg";
import finalIconDark from "../assets/sidebar/finalReviewIcon-dark.svg";
import paitentDarkIcon from "../assets/icon/Patients-icon.svg";
import productDark from "../assets/sidebar/productDark.svg";
import purchaseOrderDark from "../assets/sidebar/purchaseOrderDark.svg";
import optimizationDark from "../assets/sidebar/opti-purple.svg";
import cycleCountDark from "../assets/sidebar/cycle-countP.svg";

const dummyData = [
  {
    id: 1,
    name: "Patient",
    shortKey: "Alt + P",
    submenu: "Open Patients",
    img: paitentDarkIcon,
  },
  {
    id: 2,
    name: "Order Entry",
    shortKey: "Alt + O",
    submenu: "Go to order entry queue",
    img: orderentryIconDark,
  },
  {
    id: 3,
    name: "Claims",
    shortKey: "Alt + C",
    submenu: "Go to cliams queue",
    img: claimsIconDark,
  },
  {
    id: 4,
    name: "Initial Review",
    shortKey: "Alt + I",
    submenu: "Go to initial review queue",
    img: initialRiewDarkIcon,
  },
  {
    id: 5,
    name: "Packaging",
    shortKey: "Alt + K",
    submenu: "Go to packaging queue",
    img: packagingIconDark,
  },
  {
    id: 6,
    name: "Final Review",
    shortKey: "Alt + F",
    submenu: "Go to final review queue",
    img: finalIconDark,
  },
  {
    id: 7,
    name: "Pending",
    shortKey: "Alt + N",
    submenu: "Go to pending queue",
    img: pendingIconDark,
  },
  {
    id: 8,
    name: "Products",
    shortKey: "Ctrl + Shift + P",
    submenu: "Manage Inventory",
    img: productDark,
  },
  {
    id: 9,
    name: "Purchase Orders",
    shortKey: "Ctrl + Shift +  U",
    submenu: "Wholesaler order management",
    img: purchaseOrderDark,
  },
  {
    id: 10,
    name: "Optimization",
    shortKey: "Ctrl + Shift + O",
    submenu: "Go to inventory optimization queue",
    img: optimizationDark,
  },
  {
    id: 11,
    name: "Cycle Counts",
    shortKey: "Ctrl + Shift + Y",
    submenu: "Go to cycle count queue",
    img: cycleCountDark,
  },
  {
    id: 12,
    name: "Scheduler",
    shortKey: "Alt + Shift + D",
    submenu: "Open scheduler",
    img: cycleCountDark,
  },
  {
    id: 13,
    name: "Builder",
    shortKey: "Alt + Shift + D",
    submenu: "Open builder",
    img: cycleCountDark,
  },
];

// const searchResultData = [
//   {
//     name: "Packaging",
//     shortKey: "A",
//     submenu: "sample",
//     img: sampleIcon,
//   },
//   {
//     name: "Pending",
//     shortKey: "P",
//     submenu: "sample",
//     img: Logos,
//   },
// ];

const Header = () => {
  const { logout } = useOidc();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [hidePoweredBy, setHidePoweredBy] = useState(false);
  const [searchbar, setSearchbar] = useState(false);
  const [inputText, setInputText] = useState(null);
  const [tableData, setTableData] = useState(dummyData);
  const [suggestion, setSuggestion] = useState([]);
  const [showText, setShowText] = useState(false);
  const [] = useState("");
  const [active, setActive] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const interval = setInterval(() => {}, 1000);

    const theme = sessionStorage.getItem("theme") || "PF";

    if (theme === "PF") setHidePoweredBy(true);

    if (!access_token) {
      navigate("/");
    }
    return () => {
      clearInterval(interval);
    };
  }, []);

  const fetchData = async () => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const { sub } = profile || {};
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/users/User/getUserDetails`,
        {
          params: { Id: sub },
          headers: {
            "Content-type": "application/json",
            Authorization: `${token_type} ${access_token}`,
          },
        }
      );
      setData(data);
      setLoading(false);
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    // fetchData();
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    logout();
  };

  const handleColor = (color) => {
    setActive(color);
  };

  const searchResultData = [
    {
      name: "Packaging",
      shortKey: "A",
      submenu: "sample",
      img: sampleIcon,
    },
    {
      name: "Pending",
      shortKey: "P",
      submenu: "sample",
      img: Logos,
    },
  ];

  const commonSearchResult = [
    {
      name: "Work flow",
      shortKey: "Alt + W",
      submenu: "Open workflow dashboard",
      img: workFlowIcon,
    },
    {
      name: "Inventory",
      shortKey: "Ctrl + Shift + V",
      submenu: "Open inventory dashboard",
      img: inventoryIcon,
    },
    {
      name: "Reports",
      shortKey: "Alt + Shift + R",
      submenu: "Open reports dashboard",
      img: inventoryIcon,
    },
    {
      name: "Integrations",
      shortKey: "Ctrl + Shift + D",
      submenu: "Manage integrations",
      img: integrationIcon,
    },
    {
      name: "Admin",
      shortKey: "Alt + A",
      submenu: "Application settings",
      img: adminIcon,
    },
  ];

  const routes = {
    D: "/workflow-dashboard",
    P: "/workflow-packaging",
    R: "/reports-dashboard",
    O: "/workflow-orderEntry",
    C: "/workflow-claims",
    F: "/workflow-final",
    I: "/workflow-initial",
    M: "/workflow-patients",
  };

  const handleKeyChange = (event) => {
    const key = event.key.toUpperCase();
    if (event.altKey && key === "W") {
      event.preventDefault();
      navigate("/workflow-dashboard");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.altKey && key === "P") {
      event.preventDefault();
      navigate("/workflow-patients");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.altKey && key === "O") {
      event.preventDefault();
      navigate("/workflow-orderEntry");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.altKey && key === "C") {
      event.preventDefault();
      navigate("/workflow-claims");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.altKey && key === "I") {
      event.preventDefault();
      navigate("/workflow-initial");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.altKey && key === "K") {
      event.preventDefault();
      navigate("/workflow-packaging");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.altKey && key === "F") {
      event.preventDefault();
      navigate("/workflow-final");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.altKey && key === "N") {
      event.preventDefault();
      navigate("/workflow-pending");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.ctrlKey && event.shiftKey && key === "V") {
      event.preventDefault();
      navigate("/inventory-dashboard");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.ctrlKey && event.shiftKey && key === "P") {
      event.preventDefault();
      navigate("/inventory-products");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.ctrlKey && event.shiftKey && key === "U") {
      event.preventDefault();
      navigate("/inventory-purchase-order/tab-1");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.ctrlKey && event.shiftKey && key === "O") {
      event.preventDefault();
      navigate("/inventory-optimization");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.ctrlKey && event.shiftKey && key === "Y") {
      event.preventDefault();
      navigate("/inventory-cyclecount");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.altKey && event.shiftKey && key === "R") {
      event.preventDefault();
      navigate("/reports-dashboard");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.altKey && event.shiftKey && key === "S") {
      event.preventDefault();
      navigate("/reports-schduler");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    } else if (event.altKey && event.shiftKey && key === "B") {
      event.preventDefault();
      navigate("/reports-builder");
      setTimeout(() => {
        setSearchbar(false);
      }, 1000);
    }
    // else if (event.ctrlKey && event.altKey && key === "S") {
    //   event.preventDefault();
    //   navigate("/reports-schduler");
    //   setTimeout(() => {
    //     setSearchbar(false);
    //   }, 1000);
    // }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyChange);
    return () => {
      window.removeEventListener("keydown", handleKeyChange);
    };
  }, []);

  const handleClickSubmit = (searchResultData) => {
    if (searchResultData === "Pending") {
      navigate("/workflow-pending");
    } else if (searchResultData === "Packaging") {
      navigate("/workflow-packaging");
    } else if (searchResultData === "Work flow") {
      navigate("/workflow-dashboard");
    } else if (searchResultData === "Inventory") {
      navigate("/inventory-dashboard");
    } else if (searchResultData === "Reports") {
      navigate("/reports-dashboard");
    }
    setSearchbar(false);
  };

  const handleFilter = (e) => {
    const value = e.target.value;
    setInputText(value);
    const filteredData = tableData.filter(
      (item) =>
        item.name.toLowerCase().includes(value) ||
        item.name.toUpperCase().includes(value)
    );
    setTableData(filteredData);
    const uniqueSuggestions = [
      ...new Map(filteredData.map((item) => [item.name, item])).values(),
    ].slice(0, 5);
    setSuggestion(value ? uniqueSuggestions : []);
  };
  const handleSuggestionClick = (suggestion) => {
    setInputText(suggestion);
    setSuggestion([]);
    if (suggestion.name === "Claims") {
      navigate("/workflow-claims");
    } else if (suggestion.name === "Pending") {
      navigate("/workflow-pending");
    } else if (suggestion.name === "Order Entry") {
      navigate("/workflow-orderEntry");
    } else if (suggestion.name === "Initial Review") {
      navigate("/workflow-initial");
    } else if (suggestion.name === "Packaging") {
      navigate("/workflow-packaging");
    } else if (suggestion.name === "Final Review") {
      navigate("/workflow-final");
    } else if (suggestion.name === "Patient") {
      navigate("/workflow-patients");
    } else if (suggestion.name === "Scheduler") {
      navigate("/reports-schduler");
    } else if (suggestion.name === "Scheduler") {
      navigate("/reports-schduler");
    } else if (suggestion.name === "Builder") {
      navigate("/reports-builder");
    }

    const filteredData = tableData.filter(
      (item) =>
        item.name?.toLowerCase().includes(suggestion) ||
        item.name.toUpperCase().includes(suggestion)
    );
    setInputText(filteredData.length ? filteredData : []);
    setSearchbar(false);
  };

  useEffect(() => {
    if (inputText === "") {
      setTableData(dummyData);
    }
  }, [inputText]);

  const handleRefresh = () => {
    navigate("/workflow-dashboard");
    window.location.reload();
  };

  return (
    <>
      <Navbar color="white" light>
        <div className="pharmaforce-logo">
          <img
            src={pharmaForceLogo}
            onClick={handleRefresh}
            className="cursor-pointer"
          />
          <h6 className="ps-3 ms-3 d-inline mx-1 mt-1 mb-0 mcm_hed">
            Pharmacy Management System
          </h6>
        </div>
        <Nav>
          <div>
            <InputGroup
              onClick={(e) => e.stopPropagation()}
              className="modelInput"
            >
              <img src={inputSearchIcon} alt="not available" />
              <Input
                onClick={() => setSearchbar(true)}
                type="text"
                placeholder="Search"
                // onKeyDown={undefined}
                value={inputText}
                onChange={handleFilter}
              />
              {searchbar ? (
                <img
                  onClick={() => setSearchbar(false)}
                  src={closeIcon}
                  alt="not available"
                />
              ) : (
                ""
              )}
            </InputGroup>
            {searchbar ? (
              <>
                <div
                  className="modelPopUp"
                  onClick={() => setSearchbar(false)}
                ></div>
                <div
                  className="search-card p-box"
                  onClick={(e) => e.stopPropagation()}
                >
                  {suggestion.length > 0 ? (
                    <>
                      <>
                        <div className="search-text">Search Results</div>
                        <hr className="mt-1"></hr>
                        <>
                          {suggestion.map((suggestion, index) => (
                            <Row
                              className="row-align"
                              key={index}
                              onClick={() => handleSuggestionClick(suggestion)}
                            >
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex justify-content-between align-items-center gap-2">
                                  <Col lg={1} className="logo-bg ">
                                    <img
                                      src={suggestion.img}
                                      alt="not avilable"
                                    />
                                  </Col>
                                  <Col lg={9}>
                                    <Col className="search-data">
                                      {suggestion.name}
                                    </Col>
                                    <Col className="search-subdata">
                                      {suggestion.submenu}
                                    </Col>
                                  </Col>
                                </div>
                                <div className="short-key">
                                  {suggestion.shortKey}
                                </div>
                              </div>
                            </Row>
                          ))}{" "}
                        </>
                      </>
                    </>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center">
                      {(suggestion.name !== inputText) == "" || inputText ? (
                        <div className="f-12" style={{ fontWeight: "500" }}>
                          Data Is not found
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                  <div className="search-text">Common Actions</div>
                  <hr className="mt-1"></hr>
                  <div>
                    {commonSearchResult.map((name) => (
                      <Row
                        className="row-align"
                        onClick={() => handleClickSubmit(name.name)}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex justify-content-between align-items-center gap-2">
                            <Col lg={1} className="logo-bg">
                              <img src={name.img} alt="" />
                            </Col>
                            <Col lg={9}>
                              <Col className="search-data">{name.name}</Col>
                              <Col className="search-subdata">
                                {name.submenu}
                              </Col>
                            </Col>
                          </div>
                          <div className="short-key">{name.shortKey}</div>
                        </div>
                      </Row>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          <div className="ps-4 nav-align">
            <UncontrolledDropdown nav className="setting-dropdown">
              <DropdownToggle
                nav
                caret
                className="font-weight-500"
                style={{ fontSize: "14px" }}
              >
                <img src={messageIcon} alt="" />
              </DropdownToggle>
              <DropdownMenu className="shadow">
                <DropdownItem>Message</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav className="setting-dropdown">
              <DropdownToggle
                nav
                caret
                className="font-weight-500"
                style={{ fontSize: "14px" }}
              >
                <span>
                  <img src={bell} alt="" />
                </span>
              </DropdownToggle>
              <DropdownMenu className="shadow">
                <DropdownItem>Notification</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav className="setting-dropdown">
              <DropdownToggle
                nav
                caret
                className="font-weight-500"
                style={{ fontSize: "14px" }}
              >
                <span className="">
                  <img src={setting} alt="" />
                </span>
              </DropdownToggle>
              <DropdownMenu className="shadow">
                <DropdownItem>Setting</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav className="setting-dropdown">
              <DropdownToggle
                nav
                caret
                className="font-weight-500"
                style={{ fontSize: "14px" }}
              >
                <span className="">
                  <img src={user} alt="" />
                </span>
                {!isEmpty(data) ? data.firstName + " " + data.lastName : ""}
              </DropdownToggle>
              <DropdownMenu className="shadow">
                <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </Nav>
      </Navbar>
    </>
  );
};

export default Header;
